import { Component, Input, OnInit } from '@angular/core';
import { TabViewCustom } from '../../../_models/tab-view-custom';
import { FlujoVentaPaso } from '../../../_models/flujo-venta-paso';
import { SelectItem } from 'primeng/api';
import { ListaItem } from '../../../_models/lista-item';
import { Plantilla } from '../../../_models/plantilla';

@Component( {
  selector: 'app-flujo-venta-complementario',
  templateUrl: 'flujo-venta-complementario.component.html'
} )

export class FlujoVentaComplementarioComponent implements OnInit {

  @Input() tabView: TabViewCustom;
  @Input() secFija: boolean;
  @Input() lisPasos: FlujoVentaPaso[] = [];
  @Input() lisSecuencia: SelectItem[] = [];
  @Input() lisVinculacion: SelectItem[] = [];
  @Input() listaTiposPersonas: SelectItem[] = [];
  @Input() lisAutorizaciones: ListaItem[] = [];
  @Input() lisPlantilla: Plantilla[] = [];
  @Input() lisFases: ListaItem[] = [];
  @Input() titulo: string;
  tabSeleccionado = 'PASO';

  constructor() {
  }

  ngOnInit(): void {
  }

  abrirAcordeon( index: number ) {
    switch ( index ) {
      case 0: {
        this.tabSeleccionado = 'PASO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'RESPERXVIN';
        break;
      }
      /* case 1: {
        this.tabSeleccionado = 'DATOADJUNTO';
        break;
      } */
    }
  }

}
